export default {
  bmTitle: 'BM_TITLE',
  bmType: 'BM_TYPE',
  bmLastMeeting: 'BM_LAST_MEETING',
  bmNextMeeting: 'BM_NEXT_MEETING',
  bmNoMeeting: 'BM_NO_MEETING',
  bmMeetingName: 'BM_MEETING_NAME',
  bmGoal: 'BM_GOAL',
  bmStart: 'BM_START',
  bmCreatedInfo: 'BM_CREATED_INFO',
  bmReportMeeting: 'BM_REPORT_MEETING',
  bmMeetingPlan: 'BM_EXISTING_PLAN',
  bmGlobalInspection: 'BM_GLOBAL_INSPECTION',
  bmInspectionBundle: 'BM_INSPECTION_BUNDLE',
  bmInspectionBundleSing: 'BM_INSPECTION_BUNDLE_SING',
  bmBundleSing: 'BM_BUNDLE_SING',
  bmMeetingParticipant: 'BM_MEETING_PARTICIPANT',
  bmDocumentText: 'BM_DOCUMENT_TEXT',
  bmMeetingPresent: 'BM_MEETING_PRESENT',
  bmMeetingAbsent: 'BM_MEETING_ABSENT',
  bmMeetingCantBeHere: 'BM_MEETING_CANT_BE_HERE',
  bmSummonNextMeeting: 'BM_SUMMON_NEXT_MEETING',
  bmProgressIc: 'BM_PROGRESS_IC',
  bmNoDateIc: 'BM_NO_DATE_IC',
  bmStartIc: 'BM_START_IC',
  bmEndIc: 'BM_END_IC',
  bmCommentInfo: 'BM_COMMENT_INFO',
  bmModalTitle: 'BM_MODAL_TITLE',
  bmMeetingModalTitle: 'BM_MEETING_MODAL_TITLE',
  bmUpdateModalTitle: 'BM_UPDATE_MODAL_TITLE',
  bmMeetingUpdateModalTitle: 'BM_MEETING_UPDATE_MODAL_TITLE',
  bmModalBtnTitle: 'BM_MODAL_BTN_TITLE',
  bmUpdateModalBtnTitle: 'BM_MODAL_UPDATE_BTN_TITLE',
  bmMeetingModalBtnTitle: 'BM_MEETING_MODAL_BTN_TITLE',
  bmMeetingUpdateModalBtnTitle: 'BM_MEETING_MODAL_UPDATE_BTN_TITLE',
  bmUpdateBtn: 'BM_UPDATE_BTN',
  bmDeleteBtn: 'BM_DELETE_BTN',
  bmMeetingDeleteBtn: 'BM_MEETING_DELETE_BTN',
  bmNextMeetingSwitch: 'BM_NEXT_MEETING_SWITCH',
  bmNextMeetingLabel: 'BM_NEXT_MEETING_LABEL',
  bmCreateFromNextMeetingSwitch: 'BM_CREATE_FROM_NEXT_MEETING_SWITCH',
  bmMeeting: 'BM_MEETING',
  bmPreviousMeeting: 'BM_PREVIOUS_MEETING',
  bmStartLabel: 'BM_START_LABEL',
  bmEndLabel: 'BM_END_LABEL',
  bmStartSwitch: 'BM_START_SWITCH',
  bmEndSwitch: 'BM_END_SWITCH',
  bmArchiveBtn: 'BM_ARCHIVE_BTN',
  bmUnarchiveBtn: 'BM_UNARCHIVE_BTN',
  bmArchiveBM: 'BM_ARCHIVE_BM',
  bmUnarchiveBM: 'BM_UNARCHIVE_BM',
  bmMeetingArchiveBtn: 'BM_MEETING_ARCHIVE_BTN',
  bmMeetingUnarchiveBtn: 'BM_MEETING_UNARCHIVE_BTN',
  bmNoPlan: 'BM_NO_PLAN',
  bmNoIB: 'BM_NO_IB',
  bmContractor: 'BM_CONTRACTOR',
  bmComment: 'BM_COMMENT',
  bmGenerateReport: 'BM_GENERATE_REPORT',
  bmGenerateReportMeeting: 'BM_GENERATE_REPORT_MEETING',
  bmGenerateReportSignatures: 'BM_GENERATE_REPORT_SIGNATURES',

  bmAddParticipant: 'BM_ADD_PARTICIPANT',
  bmUpParticipant: 'BM_UP_PARTICIPANT',
  bmDelParticipant: 'BM_DEL_PARTICIPANT',

  bmAddContractor: 'BM_ADD_CONTRACTOR',
  bmUpContractor: 'BM_UP_CONTRACTOR',
  bmDelContractor: 'BM_DEL_CONTRACTOR',

  bmAddComment: 'BM_ADD_COMMENT',
  bmUpComment: 'BM_UP_COMMENT',
  bmDelComment: 'BM_DEL_COMMENT',

  bmAddPlan: 'BM_ADD_PLAN',
  bmDelPlan: 'BM_DEL_PLAN',

  bmAddIB: 'BM_ADD_IB',
  bmDelIB: 'BM_DEL_IB',
  bmParticipant: 'BM_PARTICIPANT',
  bmMeetingPresence: 'BM_MEETING_PRESENCE',
  bmSearchAllContact: 'BM_SEARCH_ALL_CONTACT',
  bmSearchAllContractor: 'BM_SEARCH_ALL_CONTRACTOR',
  bmParticipantRequired: 'BM_PARTICIPANT_REQUIRED',
  bmIBColor: 'BM_IB_COLOR',
  bmPresence: 'BM_PRESENCE',
  bmContact: 'BM_CONTACT',
  bmProject: 'BM_PROJECT',
  bmCalendar: 'BM_CALENDAR',
  bmMeetingTitle: 'BM_MEETING_TITLE',
  bmNextMeetingTitle: 'BM_NEXT_MEETING_TITLE',
  bmCustomisation: 'BM_CUSTOMISATION',
  bmHint: 'BM_HINT',
  bmContractorSing: 'BM_CONTRACTOR_SING',
  bmOptions: 'BM_OPTIONS',
  bmICLinked: 'BM_IC_LINKED',
  bmCommentTitle1: 'BM_COMMENT_TITLE1',
  bmCommentDateEnd: 'BM_COMMENT_DATE_END',
  bmCommentAddDateEnd: 'BM_COMMENT_ADD_DATE_END',
  bmCommentCreateTicket: 'BM_COMMENT_CREATE_TICKET',
  bmCommentLinkedTicket: 'BM_COMMENT_LINKED_TICKET',
  bmPlanTitle: 'BM_PLAN_TITLE',
  bmPlanLabel: 'BM_PLAN_LABEL',
  bmAddPlanTitle: 'BM_ADD_PLAN_TITLE',
  bmAddFromPlan: 'BM_ADD_FROM_PLAN',
  bmAddImportPlan: 'BM_ADD_IMPORT_PLAN',
  bmAddPlanOption: 'BM_ADD_PLAN_OPTION',
  bmDateMeetingRequired: 'BM_DATE_MEETING_REQUIRED',

  bmDeleteMember: 'BM_DELETE_MEMBER',
  bmDeletePlan: 'BM_DELETE_PLAN',
  bmDeleteContractor: 'BM_DELETE_CONTRACTOR',
  bmDeleteComment: 'BM_DELETE_COMMENT',
  bmOpenComment: 'BM_OPEN_COMMENT',
  bmCloseComment: 'BM_CLOSE_COMMENT',
  bmDeleteCommentMedia: 'BM_DELETE_COMMENT_MEDIA',
  bmDeleteIB: 'BM_DELETE_IB',
  bmCommentOpen: 'BM_COMMENT_OPEN',
  bmCommentClose: 'BM_COMMENT_CLOSE',

  end: ''
}



// WEBPACK FOOTER //
// ./src/locales/building-monitor/index.ts